import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { omit } from 'lodash';
import type { ShippingType } from '../../interfaces/contractor';

@Component({
  selector: 'app-contractor-shipping-method-cell',
  imports: [TranslatePipe],
  templateUrl: './contractor-shipping-method-cell.component.html',
  styleUrl: './contractor-shipping-method-cell.component.scss',
})
export class ContractorShippingMethodCellComponent {
  public readonly shippingType = input.required<ShippingType | undefined>();
  public readonly type = input.required<'document' | 'invoice'>();

  protected shippingMethods = computed(() =>
    Object.entries(omit(this.shippingType(), ['isOriginalDocumentRequired']))
      .filter(
        ([_, value]) =>
          value != null &&
          value !== false &&
          (!Array.isArray(value) || value.length > 0),
      )
      .map(
        ([key]) =>
          key as keyof Omit<ShippingType, 'isOriginalDocumentRequired'>,
      )
      .map(
        (key) =>
          ({
            emails: 'labels.byEmail',
            internalPortal: 'labels.internalPortal',
            traditionalMail: 'labels.traditionalMail',
          })[key],
      ),
  );
}
